module.exports = __webpack_public_path__ + "static/img/6.62f450c.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/5/1/eng/6.png
// module id = rP2t
// module chunks = 0